const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    'Content-Type': 'application/json',
    ...(token && { Authorization: `Bearer ${token}` })
  };
};

const handleResponse = async (response) => {
  if (response.status === 401) {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    window.location.reload();
    throw new Error('Session expired. Please login again.');
  }
  return response;
};

export const fetchPricePredictions = async ({
  name = '',
  phoneNumber = '',
  userbaseId = '',
  page = 1,
  limit = 20
} = {}) => {
  const query = new URLSearchParams({
    page: page.toString(),
    limit: limit.toString(),
    ...(name && { name }),
    ...(phoneNumber && { phoneNumber }),
    ...(userbaseId && { userbaseId })
  });

  let response = await fetch(`${API_BASE_URL}/price-predictions?${query.toString()}`, {
    headers: getAuthHeaders()
  });

  response = await handleResponse(response);

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response.json();
};
